export function validateLocalDomainName(localDomainName) {
  const domainRegex =
    /^(?:\*\.)?([a-zA-Z0-9а-яА-Я]|[a-zA-Z0-9а-яА-Я][a-zA-Z0-9а-яА-Я-]*[a-zA-Z0-9а-яА-Я])(?:\.([a-zA-Z0-9а-яА-Я]|[a-zA-Z0-9а-яА-Я][a-zA-Z0-9а-яА-Я-]*[a-zA-Z0-9а-яА-Я]))+$/u;

  return domainRegex.test(localDomainName);
}
